export var SEARCH_SUGGESTION_INDEX_NAME = "Search Suggestions";
export var PRODUCT_SUGGESTION_INDEX_NAME = "Products";
export var SEARCH_TRENDING_TERM_POD_ID = "best_sellers_search_suggestions";
export var SEARCH_TRENDING_PRODUCTS_POD_ID = "best_sellers_products";
export var RECENTLY_VIEWED_PRODUCTS_POD_ID = "recently-viewed-products";
export var SEARCH_INPUT_PLACEHOLDER = "Search for products and brands...";
export var RECENT_SEARCH_TERMS_KEY = "recent-search-terms";
export var MAX_RECENT_SEARCH_TERMS = 10;